import {API_URL, apiPost, apiPut} from '../api'

export const editTraderMapCampaign = async data => {
    return await apiPut(API_URL, 'admin/trader/campaign', data)
}
